import { FriendlyTimePipe } from './friendlyTime';
import { MomentPipe } from './moment';

export const Pipes: any[] = [FriendlyTimePipe, MomentPipe];

export * from './friendlyTime';
export * from './moment';
